import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { openRatingModal } from './caller-components/ratingModalStore';

let isRefreshing = false;
let failedQueue = [];


const verifyToken = (refreshToken) => {
  if (!refreshToken) {
    return false;
  }
  const decoded = jwtDecode(refreshToken);
  return decoded.exp > Date.now() / 1000;
};


const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axios(originalRequest);
        })
        .catch(err => Promise.reject(err));
      }

      isRefreshing = true;

      const refreshToken = window.localStorage.getItem("refreshToken");
      
      if(!refreshToken || !verifyToken(refreshToken)){
        window.localStorage.clear();
        window.location.href = "/new/login";
        return Promise.reject(error);
      }

      try {
        const { data } = await axios.post('/api2/v2/login/refresh/', { refresh: refreshToken });
        const newAccessToken = data.access;

        window.localStorage.setItem("serviceToken", newAccessToken);
        window.localStorage.setItem("refreshToken",data.refresh);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
        processQueue(null, newAccessToken);
        originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
        
        return axios(originalRequest);
       
      } catch (refreshError) {
        window.localStorage.clear();
        window.location.href = "/new/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false; 
      }
    }

    return Promise.reject(error);
  }
);

// ---------------------------------------------------------------------------
// Hekim Analiz Puanlama Modalı — başarılı onay/revizyon cevaplarını izler.
// Backend cevabında show_rating_modal === true varsa, URL'den analysis_pk'yi
// çıkarır ve global RatingModal'ı açar. Koşullar backend'de hesaplanır;
// frontend tekrar değerlendirmez. Tek modal instance -> aynı cevap iki kez
// işlense de yalnızca bir kere açılır; sayfa yenilendiğinde açılmaz.
// ---------------------------------------------------------------------------
const RATING_TRIGGER_PATTERN =
  /\/api2\/v2\/(analysisonay|showanalysisonay|analysisrevision|showanalysisrevision)\/(\d+)\//;

axios.interceptors.response.use((response) => {
  try {
    const url = response?.config?.url || '';
    if (RATING_TRIGGER_PATTERN.test(url) && response?.data?.show_rating_modal) {
      const match = url.match(RATING_TRIGGER_PATTERN);
      const analysisPk = match ? match[2] : null;
      const reasons = (response?.data?.rating_modal_reasons) || [];
      if (analysisPk) {
        openRatingModal(analysisPk, reasons);
      }
    }
  } catch (e) {
    // puanlama modalı tetiklemesi asla ana akışı bozmamalı
  }
  return response;
});

export default axios;
